import { Divider } from '../Divider';

interface Props {
  isMobile?: boolean;
  orientation?: 'vertical' | 'horizontal';
}

export const MenuDivider = ({ isMobile = false, orientation }: Props) => {
  return (
    <Divider
      orientation={
        orientation !== undefined
          ? orientation
          : isMobile
          ? 'horizontal'
          : 'vertical'
      }
      colorMode="dark"
    />
  );
};
